import { createContext, useState, useCallback, useMemo, type ReactNode } from 'react';

interface AppContextValue {
  pageTitle: string;
  setPageTitle: (title: string) => void;
  isSearchOpen: boolean;
  toggleSearch: () => void;
  globalLoading: boolean;
  setGlobalLoading: (loading: boolean) => void;
}

export const AppContext = createContext<AppContextValue>({
  pageTitle: 'Dashboard',
  setPageTitle: () => {},
  isSearchOpen: false,
  toggleSearch: () => {},
  globalLoading: false,
  setGlobalLoading: () => {},
});

interface AppProviderProps {
  children: ReactNode;
}

export function AppProvider({ children }: AppProviderProps) {
  const [pageTitle, setPageTitle] = useState('Dashboard');
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [globalLoading, setGlobalLoading] = useState(false);

  const toggleSearch = useCallback(() => {
    setIsSearchOpen((prev) => !prev);
  }, []);

  const contextValue = useMemo(
    () => ({ pageTitle, setPageTitle, isSearchOpen, toggleSearch, globalLoading, setGlobalLoading }),
    [pageTitle, isSearchOpen, toggleSearch, globalLoading],
  );

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
}
